module.exports = __webpack_public_path__ + "img/zhzizhi.0506f894.png";